import { render, staticRenderFns } from "./ContactMergeModal.vue?vue&type=template&id=b515cac6&scoped=true&"
import script from "./ContactMergeModal.vue?vue&type=script&lang=js&"
export * from "./ContactMergeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b515cac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b515cac6')) {
      api.createRecord('b515cac6', component.options)
    } else {
      api.reload('b515cac6', component.options)
    }
    module.hot.accept("./ContactMergeModal.vue?vue&type=template&id=b515cac6&scoped=true&", function () {
      api.rerender('b515cac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/contact/ContactMergeModal.vue"
export default component.exports